export const getFieldTranslations = (t: any) => ({
  name: t("m2_static_data.columns.name", { ns: "tables", defaultValue: "Nom" }),
  currency: t("m2_static_data.columns.currency", {
    ns: "tables",
    defaultValue: "Devise",
  }),
  isin: t("m2_static_data.columns.isin", {
    ns: "tables",
    defaultValue: "ISIN",
  }),
  code: t("m2_static_data.columns.code", {
    ns: "tables",
    defaultValue: "Code",
  }),
  ticker: t("m2_static_data.columns.ticker", {
    ns: "tables",
    defaultValue: "Ticker",
  }),
  company_name: t("m2_static_data.columns.company_name", {
    ns: "tables",
    defaultValue: "Société de gestion",
  }),
  asset_class_1: t("m2_static_data.columns.asset_class_1", {
    ns: "tables",
    defaultValue: "Classe d'actif principale",
  }),
  asset_class_2: t("m2_static_data.columns.asset_class_2", {
    ns: "tables",
    defaultValue: "Classe d'actifs",
  }),
  m2_issuer_name: t("m2_static_data.columns.m2_issuer_name", {
    ns: "tables",
    defaultValue: "Émetteur",
  }),
  strategy_id: t("m2_static_data.columns.strategy_id", {
    ns: "tables",
    defaultValue: "ID de la stratégie",
  }),
  loan_rate: t("m2_static_data.columns.loan_rate", {
    ns: "tables",
    defaultValue: "Taux du prêt",
  }),
  loan_amount_granted: t("m2_static_data.columns.loan_amount_granted", {
    ns: "tables",
    defaultValue: "Montant du prêt accordé",
  }),
  loan_with_collateral: t("m2_static_data.columns.loan_with_collateral", {
    ns: "tables",
    defaultValue: "Prêt consenti avec nantissement",
  }),
  maturity_date: t("m2_static_data.columns.maturity_date", {
    ns: "tables",
    defaultValue: "Date de maturité",
  }),
  coupon_rate: t("m2_static_data.columns.coupon_rate", {
    ns: "tables",
    defaultValue: "Taux du coupon",
  }),
  commitment: t("m2_static_data.columns.commitment", {
    ns: "tables",
    defaultValue: "Engagement initial",
  }),
  capital_callable: t("m2_static_data.columns.capital_callable", {
    ns: "tables",
    defaultValue: "Capital exigible",
  }),
  owner: t("m2_static_data.columns.owner", {
    ns: "tables",
    defaultValue: "Propriétaire",
  }),
  property_id: t("m2_static_data.columns.property_id", {
    ns: "tables",
    defaultValue: "ID de la propriété",
  }),
  property_type: t("m2_static_data.columns.property_type", {
    ns: "tables",
    defaultValue: "Type de bien",
  }),
  property_size: t("m2_static_data.columns.property_size", {
    ns: "tables",
    defaultValue: "Taille du bien",
  }),
  financing_own_funds: t("m2_static_data.columns.financing_own_funds", {
    ns: "tables",
    defaultValue: "Financement fonds propres",
  }),
  financing_mortage: t("m2_static_data.columns.financing_mortage", {
    ns: "tables",
    defaultValue: "Financement hypothécaire",
  }),
  stock_option_strike: t("m2_static_data.columns.stock_option_strike", {
    ns: "tables",
    defaultValue: "Prix d'exercice",
  }),
  climate_risk: t("m2_static_data.columns.climate_risk", {
    ns: "tables",
    defaultValue: "Risque climatique",
  }),
  custodian: t("m2_static_data.columns.custodian", {
    ns: "tables",
    defaultValue: "Dépositaire",
  }),
  custodian_code: t("m2_static_data.columns.custodian_code", {
    ns: "tables",
    defaultValue: "Code dépositaire",
  }),
  custodian_code_type: t("m2_static_data.columns.custodian_code_type", {
    ns: "tables",
    defaultValue: "Type de code dépositaire",
  }),
  custodian_country_code: t("m2_static_data.columns.custodian_country_code", {
    ns: "tables",
    defaultValue: "Pays du dépositaire",
  }),
  valuation_method: t("m2_static_data.columns.valuation_method", {
    ns: "tables",
    defaultValue: "Méthode de valorisation",
  }),
  shock_type: t("m2_static_data.columns.shock_type", {
    ns: "tables",
    defaultValue: "Type de choc",
  }),
  created_at: t("technical_info.created_at", { defaultValue: "Créé le" }),
  updated_at: t("technical_info.updated_at", { defaultValue: "Mis à jour le" }),
});

export default getFieldTranslations;
